import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

interface IProps {
  type?: 'default' | 'success' | 'caution' | 'info' | 'warning' | 'error'
  btnText?: string
  icon?: string
  closable?: boolean
  text?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KTtoast' },
  __name: 'KToast',
  props: {
    type: { default: 'default' },
    btnText: { default: '' },
    icon: { default: '' },
    closable: { type: Boolean, default: false },
    text: { default: '' }
  },
  emits: ['close', 'action'],
  setup(__props: any, { emit: __emit }) {



const props = __props

const emits = __emit

const properties = computed(() => {
  const typeSettings = {
    default: {
      style: 'default-toast',
      textColorClass: 'default-toast-text',
      icon: '',
      iconColor: '',
    },
    success: {
      style: 'bg-success-20',
      textColorClass: 'text-success-100',
      icon: 'trash',
      iconColor: 'success-100',
    },
    caution: {
      style: 'bg-caution-20',
      textColorClass: 'text-caution-100',
      icon: 'trash',
      iconColor: 'caution-100',
    },
    info: {
      style: 'bg-caution-20',
      textColorClass: 'text-caution-100',
      icon: 'warning',
      iconColor: 'caution-100',
    },
    warning: {
      style: 'bg-error-20',
      textColorClass: 'text-error-100',
      icon: 'trash',
      iconColor: 'error-100',
    },
    error: {
      style: 'bg-error-20',
      textColorClass: 'text-error-100',
      icon: 'remove-solid',
      iconColor: 'error-100',
    },
  }

  return typeSettings[props.type] || {}
})

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-toast rounded-32 row items-center q-py-md q-px-lg", properties.value.style])
  }, [
    (__props.type !== 'default')
      ? (_openBlock(), _createBlock(_component_KIcon, {
          key: 0,
          name: !__props.icon ? properties.value.icon : __props.icon,
          color: properties.value.iconColor,
          class: "q-mr-md"
        }, null, 8 /* PROPS */, ["name", "color"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", {
      class: _normalizeClass(["fw-500 fs-16px flex-1", properties.value.textColorClass])
    }, _toDisplayString(__props.text), 3 /* TEXT, CLASS */),
    (__props.closable)
      ? (_openBlock(), _createBlock(_component_KIcon, {
          key: 1,
          class: "q-ml-sm text-center",
          name: "remove",
          color: "cool-gray-70 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }))
      : _createCommentVNode("v-if", true),
    (__props.btnText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "q-ml-lg fs-15px fw-500 cursor-pointer text-space-b-100",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action')))
        }, _toDisplayString(__props.btnText), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})